import {
  FaCalendarCheck,
  FaCircleCheck,
  FaDatabase,
  FaGears,
  FaHouse,
  FaLayerGroup,
  FaListCheck,
  FaLocationDot,
  FaSquareCaretRight,
  FaStar,
  FaTruck,
  FaUsers,
} from "react-icons/fa6";

const MenuKeamanan = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Operasional",
    type: "menu-title",
  },
  {
    label: "Cek Mobil",
    to: "transaksi/cek-keluar-masuk",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Mobil",
    to: "problem/problem-kendaraan",
    icon: <FaGears />,
  },
  {
    label: "Operasional Trado",
    type: "menu-title",
  },
  {
    label: "Cek Trado",
    to: "transaksi/cek-keluar-masuk-trado",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Trado",
    to: "problem/problem-kendaraan-trado",
    icon: <FaGears />,
  },
  {
    label: "Lain-Lain",
    type: "menu-title",
  },
];

export default MenuKeamanan;
